module.exports = __webpack_public_path__ + "static/media/APP_NightWatch_152x174_6.6d9e0d94.png";